// extracted by mini-css-extract-plugin
export default {"filled":"ReviewRating_filled__pNxIi","unfilled":"ReviewRating_unfilled__KBExk"};